// 見出しアニメーション

function scrollAddClass() {
  const scrollEffect = document.querySelectorAll('.custom-image-with-text-1 .image-with-text__heading');
  let windowHeight = window.innerHeight;
  for (let i = 0; i < scrollEffect.length; i++) {
    target = scrollEffect[i].getBoundingClientRect().top;
    if (target < windowHeight) {
      scrollEffect[i].classList.add('is-active');
    }
  }
}
document.addEventListener('DOMContentLoaded', scrollAddClass);
document.addEventListener('scroll', scrollAddClass);

  
// パララックス
/*
image-banner.liquid にパララックスを設定する項目を追加
id「custom_img_parallax」が該当項目。
チェックボックスにチェックが付くと.custom-js-parallax が付与されます。
idは変更しない
labelとinfoは適宜変更
*/
(function () {
  function importScriptPromise(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      script.async = true;
      script.addEventListener("load", () => resolve(script), false);
      script.addEventListener("error", () => reject(script), false);
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }

  function initParallax() {
    if (document.querySelector(".custom-js-parallax img") === null) return;
    const targets = document.querySelectorAll(".custom-js-parallax img");
    const pluginUrl = "https://cdn.jsdelivr.net/npm/simple-parallax-js@5.5.1/dist/simpleParallax.min.js";
    importScriptPromise(pluginUrl).then(() => {
      new simpleParallax(targets);
    });
  }

  window.addEventListener("DOMContentLoaded", (event) => {
    initParallax();
  });
}());

// 目次
/*
カスタマイズされたLiquidを作成して以下を入力。data属性値は変更可能

idは変更不可
data-toc-selectors: 目次にする見出し
data-toc-headline-class-name: 目次にする見出しに付与するクラス名
data-toc-href-prefix: 目次のhref値に付ける Prefix
data-toc-active: 目次の見出しがアクティブ時に追加するクラス名

参考コード：https://codepen.io/sledsworth/pen/EqvgNy

コード例
<div
id="custom-js-toc"
data-toc-selectors="#MainContent .h1"
data-toc-headline-class-name="custom-toc-title"
data-toc-href-prefix="toc"
data-toc-active="custom-toc-active"
></div>
*/

(function () {
  let headingIntersectionData = {};

  function setLinkActive(links, link, className){
    links.forEach((link) => link.classList.remove(className));
    if (link) {
      link.classList.add(className);
    }
  }

  function updateActiveHeadingOnIntersection(entry, toc, headlines, options) {
    const headlinesArr = Array.from(headlines);
    const items = Array.from(toc.querySelectorAll('li'));
    const previousY = headingIntersectionData[entry.target.id].y;
    const currentY = entry.boundingClientRect.y;
    const id = `#${entry.target.id}`;
    const link = toc.querySelector(`.${entry.target.id}`);
    const index = headlinesArr.indexOf(entry.target);

    if (entry.isIntersecting) {
      if (currentY > previousY && index !== 0) {
        // console.log(id + ":1 enter top");
      } else {
        // console.log(id + ":2 enter bottom");
        setLinkActive(items, link, options.active);
      }
    } else {
      if (currentY > previousY) {
        // console.log(id + ":3 leave bottom");
        const lastLink = items[index - 1];
        setLinkActive(items, lastLink, options.active);
      } else {
        // console.log(id + ":4 leave top");
      }
    }

    headingIntersectionData[entry.target.id].y = currentY;
  }

  function highlightToc(toc, headlines, options) {
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        updateActiveHeadingOnIntersection(entry, toc, headlines, options)
      });
    };

    const observer = new IntersectionObserver(observerCallback,
      {
        root: null,
        threshold: 0.1
      }
    );

    Array.from(headlines).reverse().forEach((item) => {
      headingIntersectionData[item.id] = {
        y: 0
      };
      observer.observe(item);
    });
  }

  function createItem(text, index, options) {
    const li = document.createElement('li');
    const a = document.createElement('a');
    const textNode = document.createTextNode(text);
    a.href = `#${options.hrefPrefix}-${index}`;
    a.appendChild(textNode);
    li.appendChild(a);
    li.classList.add(`${options.hrefPrefix}-${index}`);
    return li;
  }

  function createToc(headlines, options) {
    const wrapperRoot = document.createElement('ul');
    const fragmentRoot = document.createDocumentFragment();

    Array.from(headlines).forEach((target, index) => {
      target.classList.add(options.headlineClassName);
      target.id = `${options.hrefPrefix}-${index}`;

      const text = target.textContent;
      const li = createItem(text, index, options);
      fragmentRoot.appendChild(li);
    });

    wrapperRoot.appendChild(fragmentRoot);
    return wrapperRoot;
  }

  function initToc() {
    const target = document.getElementById("custom-js-toc");
    if (target === null) return;
    const selectorName = target.dataset.tocSelectors;
    const headlines = document.querySelectorAll(selectorName);
    const options = {
      headlineClassName: target.dataset.tocHeadlineClassName,
      hrefPrefix: target.dataset.tocHrefPrefix,
      active: target.dataset.tocActive
    }
    if (headlines.length <= 0) return;
    const toc = createToc(headlines, options);
    target.appendChild(toc);
    highlightToc(toc, headlines, options);
  }

  window.addEventListener("DOMContentLoaded", (event) => {
    initToc();
  });
}());

// TOPのAbout
/*
data-sticky-parent-id に追従させたいエリアのid属性値を入れます。
追従は、.custom-js-stickyにcssでposition: sticky; を指定

コード例
<div class="custom-js-sticky" data-sticky-parent-id="hoge"><div>
*/
(function () {
  function initSticky() {
    if (document.querySelector(".custom-js-sticky") === null) return;
    const targets = document.querySelectorAll(".custom-js-sticky");
    Array.from(targets).forEach((target) => {
      const parentId = target.dataset.stickyParentId;
      const parent = document.getElementById(parentId);
      if (parent === null) return;
      const child = parent.firstChild
      parent.appendChild(target);
      parent.insertBefore(target, child);
    });
  }

  window.addEventListener("DOMContentLoaded", (event) => {
    initSticky();
  });
}());

// ページの先頭に戻る
/*
<a href="#top"></a>はページ内に1つしかないという条件で作成しています。
*/
(function () {
    const throttle = (func, wait) => {
        let timeoutID;
        let lastCallTime;
        if (typeof func !== 'function') {
            throw new TypeError('Expected a function');
        }
        return function () {
            const context = this;
            const args = arguments;
            const execute = () => {
                func.apply(context, args);
                lastCallTime = Date.now();
            };
            if (!lastCallTime) {
                execute();
            } else {
                clearTimeout(timeoutID);
                const time = Date.now();
                const timeSinceLastCall = time - lastCallTime;
                const delay = wait - timeSinceLastCall;
                timeoutID = setTimeout(execute, delay);
            }
        };
    };

    window.addEventListener("DOMContentLoaded", (event) => {
        const target = document.querySelector('[href="#top"]');
        if (target === null) return;
        let lastKnownScrollPosition = 0;
        let currentScrollY = 0;
        const height = target.clientHeight;

        function scroollTopSmooth(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

        function toggle() {
            currentScrollY = window.pageYOffset;
            const viewportHeigh = window.innerHeight;
            const showHeight = viewportHeigh / 2;

            if (currentScrollY >= showHeight) {
                target.classList.add('is-show');
            } else {
                target.classList.remove('is-show');
            }

            lastKnownScrollPosition = currentScrollY;
        }

        target.addEventListener("click", scroollTopSmooth, false);
        window.addEventListener('scroll', throttle(toggle, 200), { passive: true });
    });
}());